import { TGraphicDesignLessonConfig, TGDRule } from '../../../models/courses/graphicDesign';

export const deriveCritiqueConfig = (
  config: TGraphicDesignLessonConfig
): TGraphicDesignLessonConfig => {
  if (config.rules.some(rule => rule.type === 'zoneFound')) return config;
  const rules: TGDRule[] = (config.zones ?? []).map((zone, index) => ({
    id: `zone-${zone.id}`,
    type: 'zoneFound',
    params: { zoneId: zone.id },
    tier: 'required',
    label: {
      fr: `Erreur ${index + 1} trouvée`,
      en: `Mistake ${index + 1} found`,
      ar: `الخطأ ${index + 1} وُجد`,
    },
  }));
  // Seules les zones sont generees : les autres regles (bonus rapidite) restent actives.
  return { ...config, rules: [...rules, ...config.rules], requiredRules: config.requiredRules > 0
    ? config.requiredRules : (config.zones ?? []).length };
};
